import { render, staticRenderFns } from "./transactionConfigDetailComponent.vue?vue&type=template&id=4b656cd4&scoped=true&"
import script from "./transactionConfigDetailComponent.vue?vue&type=script&lang=js&"
export * from "./transactionConfigDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionConfigDetailComponent.vue?vue&type=style&index=0&id=4b656cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b656cd4",
  null
  
)

export default component.exports